// removed by extract-text-webpack-plugin
module.exports = {"ClassType":"_16_1t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/SelectedFlight/SelectedFlight.scss
// module id = 366
// module chunks = 0